var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C8.08362 0.00333504 5.28763 1.18443 3.22544 3.28417C1.16325 5.38391 0.0032754 8.23081 0 11.2003C0 15.7574 3.24913 19.5417 6.69075 23.5472C7.77975 24.8156 8.90725 26.1275 9.911 27.4547C10.0394 27.6244 10.2044 27.7618 10.3932 27.8563C10.582 27.9508 10.7896 28 11 28C11.2104 28 11.418 27.9508 11.6068 27.8563C11.7956 27.7618 11.9606 27.6244 12.089 27.4547C13.0927 26.1275 14.2203 24.8156 15.3092 23.5472C18.7509 19.5417 22 15.7574 22 11.2003C21.9967 8.23081 20.8367 5.38391 18.7746 3.28417C16.7124 1.18443 13.9164 0.00333504 11 0ZM11 15.4004C10.1842 15.4004 9.38663 15.1541 8.70827 14.6926C8.02992 14.231 7.50121 13.5751 7.189 12.8076C6.87679 12.0401 6.7951 11.1956 6.95426 10.3809C7.11342 9.56615 7.50629 8.81776 8.08318 8.23037C8.66008 7.64297 9.39508 7.24295 10.1953 7.08089C10.9954 6.91882 11.8248 7.002 12.5786 7.3199C13.3323 7.63779 13.9766 8.17613 14.4298 8.86684C14.8831 9.55754 15.125 10.3696 15.125 11.2003C15.125 12.3142 14.6904 13.3825 13.9168 14.1702C13.1432 14.9579 12.094 15.4004 11 15.4004Z",
    fill: "#4982F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1357bedc1dd4c64fa2649d0fcf5c0dbe.svg";
export { ForwardRef as ReactComponent };